import { Component, Prop, Mixins } from "vue-property-decorator";
import { DynPanelAware } from '@/components/dyn-panel';
import PanelConfirm from './panel-confirm';

type ConfirmOptions = {
  message?: string;
  title?: string;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string
}

@Component
export default class ActConfirm extends Mixins(DynPanelAware) {

  @Prop({required: false, default: () => ({})}) readonly confirmOptions!: ConfirmOptions;
  @Prop({required: false}) readonly confirmMessage!: string;

  @Prop({default: "a"}) readonly tag!: string;

  onElClick() { 
    this.pushPanel({
      clazz: PanelConfirm,
      props: {
        ...this.confirmOptions
      },
      on: {
        commit: ({emitter}) => {
          this.$emit("click");
          emitter.remove();
        }
      }
    });
  }

  render(h) {
    return h(
      this.tag,
      {
        on: {
          click: () => this.onElClick()
        }
      },
      this.$slots.default
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3dd76f52/act-confirm.tsx" });